export interface Bonus {
  image: string
  alt: string
  title: string
  description: string
  price: string
}

export const bonuses: Bonus[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/jYQ9BfoiwBsvubKXD5rQHf/Captura_de_pantalla_2026-09-13_a_la(s)_11.52.01_p._m..png',
    alt: "Cover of the bonus Women's Lacrosse Rules Made Simple",
    title: "Women's Lacrosse Rules Made Simple",
    description: 'Every rule you need, in plain English, with referee signals and a sideline cheat sheet.',
    price: '$29',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/aJNfg4oKsQK6qNpTrdtXZT/Captura_de_pantalla_2026-09-13_a_la(s)_11.52.12_p._m..png',
    alt: 'Cover of the bonus The Lacrosse Parent Pack',
    title: 'The Lacrosse Parent Pack',
    description: 'Meeting scripts, 8 ready-to-send email templates and a parent code of conduct.',
    price: '$24',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/vGZhKmJo4tBJbqWFL57XqY/Captura_de_pantalla_2026-09-13_a_la(s)_11.52.23_p._m..png',
    alt: 'Cover of the bonus Wall Ball Homework',
    title: 'Wall Ball Homework',
    description: 'A 30-day at-home practice program you hand straight to your players.',
    price: '$19',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/oDPogHGhjZ57HtNJ4qmr4o/Captura_de_pantalla_2026-09-13_a_la(s)_11.52.35_p._m..png',
    alt: 'Cover of the bonus Game Day Command Center',
    title: 'Game Day Command Center',
    description: 'Lineup sheets, half-time scripts and the in-game problem solver, ready for your clipboard.',
    price: '$27',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/8pJvy1wrnUoZCuMaKFm6kv/Captura_de_pantalla_2026-09-13_a_la(s)_11.52.45_p._m..png',
    alt: 'Cover of the bonus The Goalkeeper Starter Guide',
    title: 'The Goalkeeper Starter Guide',
    description: 'How to train a confident keeper even if you have never stood in the cage.',
    price: '$25',
  },
]
